module.exports = __webpack_public_path__ + "static/media/card_digitize.671327d2.png";